import React, { useEffect, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";

const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
};

const focusedStyle = {
    borderColor: "#2196f3",
};

const acceptStyle = {
    borderColor: "#00e676",
};

const rejectStyle = {
    borderColor: "#ff1744",
};

function StyledDropzone({ accept, onDrop, loading, file }) {
    const [acceptedFileImage, setAcceptedFileImage] = useState(null);

    useEffect(() => {
        if (file) {
            setAcceptedFileImage(URL.createObjectURL(file));
        }
    }, [file]);

    const handleOnDrop = (files) => {
        onDrop?.(files[0]);
    };
    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject,
    } = useDropzone({
        accept: accept,
        onDrop: handleOnDrop,
    });

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isFocused, isDragAccept, isDragReject]
    );

    const containerStyle = {
        minHeight: "150px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    };

    return (
        <div className="container" style={containerStyle}>
            <div
                {...getRootProps({ style })}
                style={
                    loading
                        ? { opacity: 0.5, width: "100%" }
                        : { width: "100%" }
                }
            >
                <input {...getInputProps()} disabled={loading} />

                {file ? (
                    <img src={acceptedFileImage} style={{ width: "100%" }} />
                ) : (
                    <p>
                        Drag 'n' drop some files here, or click to select files
                    </p>
                )}
            </div>
        </div>
    );
}

export default StyledDropzone;
